import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL, promiseAreas} from '../../util/uiconstants';

export function getProjectToEdit(projectId, includeContactDetail) {
	let url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}?IncludeContactsDetails=${includeContactDetail}`;

	return {
		type: types.GET_PROJECT_TO_EDIT,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.GET_PROJECT_DETAILS_AREA
			}
		}
	};
}

export function setEditMode(activated, redirect, nodes, setNodes) {
	const isEditMode = {
		activated,
		redirect,
		nodes,
		setNodes
	};
	return {
		type: types.SET_EDIT_MODE,
		isEditMode
	};
}
